import styled from 'styled-components';
import { THEME } from 'src/styles/theme';
import { mobileBreakpoint } from 'src/containers/client-assessment/mobileBreakpoint';

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: ${props => props.theme.main};
    margin-bottom: 0.2em;
  }

  h2 {
    font-size: 28px;
    font-weight: 500;
    color: ${props => props.theme.black};
  }
`;

type FlexRowProps = {
  justify?: string;
  height?: boolean;
};

export const FlexRow = styled.div`
  display: flex;
  justify-content: ${(props: FlexRowProps) =>
    props.justify ? props.justify : 'center'};
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  height: ${(props: FlexRowProps) => (props.height ? '48vh' : 'auto')};
  overflow: ${(props: FlexRowProps) => (props.height ? 'auto' : 'unset')};
  @media ${mobileBreakpoint.mobile} {
    max-height: 35vh;
    overflow-y: scroll;
  }
`;

type OptionTileProps = {
  selected?: boolean;
  direction?: 'row' | 'column';
  alignItems?: string;
};

export const OptionTile = styled.div`
  padding: 2em 3.1em;
  border-radius: 4px;
  background-color: ${props => props.theme.main.white};
  color: #475467;
  border: ${(props: OptionTileProps) =>
    props.selected ? '2px solid #457F8F' : '1px solid#E4E7EC'};

  display: flex;
  flex-direction: ${(props: OptionTileProps) =>
    props.direction === 'row' ? 'row' : 'column'};
  justify-content: center;
  align-items: ${(props: OptionTileProps) =>
    props.alignItems ? props.alignItems : 'center'};
  min-width: 15%;
  min-height: 6em;
  margin-right: 1.5em;
  margin-bottom: 1em;
  text-align: center;
  width: 100%;
  @media ${mobileBreakpoint.mobile} {
    margin-bottom: 0.8em;
    min-height: 4em;
    padding: 1.4em 3em;
  }
  span {
    font-size: 16px;
    font-weight: 500;
  }

  &:hover {
    cursor: pointer;
    background-color: #f9fafb;
  }
`;

export const RetirementAgeInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  .error-msg {
    font-size: 10px;
    margin: 4px 0 0 16px;
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const RetirementAgeInput = styled.input`
  border: 1px solid #e4e7ec;
  box-shadow: inset 1px 2px 2px rgba(16, 24, 40, 0.12);
  border-radius: 4px;
  width: 80px;
  margin-left: 16px;
`;
